import { AuthGatewayContainer } from '@/components/pages/Auth/Gateway';

export { AuthGatewayContainer as AuthGatewayPage };
